import { useContext } from "react";
import { UsersApiContext } from "utils/providers";

export const useUsersApi = () => {
  return useContext(UsersApiContext);
};
